import Cookies from 'js-cookie';

(function ($) {
    const $announcementBar = $('.announcement-bar');
    const $announcementClose = $announcementBar.find('.announcement-bar__announcement-close');

    if ($announcementBar && $announcementClose.length) {
      const announcementCookieName = 'announcement-closed';
      const announcementCookie = Cookies.get(announcementCookieName);
      const announcementClose = function () {
        $announcementBar.slideUp();
      }
      const announcementOpen = function () {
        $announcementBar.addClass('open');
        $announcementBar.slideDown();
      }

    $announcementClose.on('click', function () {
      Cookies.set(announcementCookieName, 'true');
      announcementClose();
    });

    if (!announcementCookie || announcementCookie != 'true') {
      announcementOpen();
    }
  }
})(jQuery);
